<template>
  <div class="w-56 shrink-0">
    <RichSelectField
      :aria-label="t('Reviews.product.insights.filters.category.label')"
      size="s"
      :model-value="category"
      data-testid="insights-category-button"
      @update:model-value="onSelect"
    >
      <template #prepend>
        <FilterIcon class="lucide-icon-s" />
      </template>
      <RichSelectOption
        v-for="option in options"
        :key="option.slug"
        :value="option.slug"
        :label="option.title"
        :data-testid="`insights-category-option-${option.slug}`"
      />
    </RichSelectField>
  </div>
</template>

<script setup lang="ts">
import { RichSelectField, RichSelectOption } from '@ramp106/omrjs-core-ui'
import { FilterIcon } from '@ramp106/omrjs-core-ui/icons'
import { useI18n } from 'vue-i18n'

import type { ProductById } from '@/gql/reviews'

import { useRouterQueryInsightsCategory } from './useRouterQueryInsightsCategory'

const props = defineProps<{ product: ProductById }>()

const { t } = useI18n()
const { category, options, setCategory } = useRouterQueryInsightsCategory(() => props.product)

function onSelect(slug: string | string[]) {
  if (typeof slug === 'string') setCategory(slug)
}
</script>
